import baseAxios from "../core/api/axios/baseAxios";

class LocationService {
  //=======================================
  //===Get all Location ====
  //=======================================
  static async getLocations() {
    const res = await baseAxios.get("/v2/dashboard/details?type=allLocations&allowPickers=true");
    return { ...res.data, data: res.data.data.data };
  }

  //=======================================
  //===Create new Location ====
  //=======================================
  static async createLocation(data) {
    const res = await baseAxios.post("/location/create", data);
    return res?.data || res;
  }

  //=======================================
  //===Modify Location ====
  //=======================================
  static async modifyLocation(id, data) {
    const res = await baseAxios.put(`/location/${id}`, data);
    return res?.data || res;
  }

  //=======================================
  //===Delete Location ====
  //=======================================
  static async deleteLocation(id) {
    const res = await baseAxios.delete(`/location/${id}`);
    return res?.data || res;
  }

  //=======================================
  //===Get World Locations ====
  //=======================================
  static async getWorldLocations() {
    const res = await baseAxios.get("/v2/location/world-location");
    return res?.data || res;
  }
}

export default LocationService;
